"use client"

import { useState } from "react"
import "../css/contacto.css"

import logo from "../img/yeti.png"
import imgcont from "../img/imgcont.png"

const Contacto = () => {
  const [formData, setFormData] = useState({
    nombre: "",
    telefono: "",
    correo: "",
    servicio: "",
    mensaje: "",
  })

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [alert, setAlert] = useState({ show: false, type: '', message: '' })

  const showAlert = (type, message) => {
    setAlert({ show: true, type, message })
    setTimeout(() => setAlert({ show: false, type: '', message: '' }), 3000)
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!formData.servicio) {
      showAlert('error', 'Selecciona una línea de productos')
      return
    }
    setIsSubmitting(true)

    try {
      const dataToSend = {
        name: formData.nombre,
        phone: formData.telefono,
        mail: formData.correo,   // 👈 el backend espera "mail"
        service: formData.servicio,
        message: formData.mensaje,
      }

      const response = await fetch("https://www.yetiadvisers.com/send_contactigle", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataToSend),
      })

      if (response.ok) {
        setFormData({
          nombre: "",
          telefono: "",
          correo: "",
          servicio: "",
          mensaje: "",
        })
        showAlert('success', 'Gracias, nos pondremos en contacto contigo')
      } else {
        throw new Error("Error al enviar el mensaje")
      }
    } catch (err) {
      console.error(err)
      showAlert('error', 'Error al enviar el mensaje. Por favor, inténtalo de nuevo.')
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <section className="contact-section">
      {/* Popup */}
      {alert.show && (
        <div className="popup-overlay">
          <div className={`popup ${alert.type}`}>
            <span className="popup-icon">{alert.type === 'success' ? '✓' : '✕'}</span>
            <p>{alert.message}</p>
          </div>
        </div>
      )}

      <div className="contact-form">
        <div className="logo">
          <img src={logo} alt="Logo" />
        </div>
        <h2>Contáctate con nosotros</h2>
        <p>Completa el siguiente formulario y uno de nuestros agentes se comunicará contigo.</p>

        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <input
              type="text"
              name="nombre"
              placeholder="Nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            />
            <input
              type="tel"
              name="telefono"
              placeholder="Teléfono"
              value={formData.telefono}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            />
          </div>

          <div className="form-row">
            <input
              type="email"
              name="correo"
              placeholder="Dirección de correo electrónico"
              value={formData.correo}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            />
            <select
              name="servicio"
              value={formData.servicio}
              onChange={handleChange}
              required
              disabled={isSubmitting}
            >
              <option value="">Línea de Productos</option>
              <option value="Repuestos automotrices">Repuestos automotrices</option>
              <option value="Repuestos industriales">Repuestos industriales</option>
              <option value="Aceros">Aceros</option>
            </select>
          </div>

          <textarea
            name="mensaje"
            placeholder="Consulta"
            value={formData.mensaje}
            onChange={handleChange}
            rows="4"
            required
            disabled={isSubmitting}
          />

          <button type="submit" className="btn-submit" disabled={isSubmitting}>
            {isSubmitting ? "ENVIANDO..." : "ENVIAR"}
          </button>
        </form>
      </div>

      <div className="contact-image">
        <img src={imgcont} alt="Imagen contacto" />
      </div>
    </section>
  )
}

export default Contacto
